/** @format */

import {useAcceptJs} from 'react-acceptjs';
import React, {useState} from 'react';

const authData = {
    apiLoginID: process.env.AUTHORIZE_LOGIN,
    clientKey: process.env.AUTHORIZE_CLIENT_KEY
};

export const useVerifyPaymentProfile = ({bankData, cardData}) => {
    const environment = process.env.AUTHORIZE_MODE === 'live' ? 'PRODUCTION' : 'SANDBOX';
    const {dispatchData} = useAcceptJs({environment, authData});

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [data, setData] = useState(null);

    const handleVerifyPaymentProfile = async event => {
        event.preventDefault();

        setIsLoading(true);
        setError('');

        const dataToVerify = cardData ? {cardData} : {bankData};
        // Dispatch CC data to Authorize.net and receive payment nonce for use on your server
        try {
            const response = await dispatchData(dataToVerify);
            // update the context with the nonce data and the card data
            setData(response);
            setIsLoading(false);
        } catch (e) {
            setIsLoading(false);
            setData(null);
            setError(
                e.messages.message
                    .map(a => {
                        return a.text;
                    })
                    .join(' AND ')
            );
        }
    };

    return {
        handleVerifyPaymentProfile,
        isLoading,
        error,
        data
    };
};
